//import $ from 'jQuery';
import vars from '../../../../vars.js';

const { grecaptcha } = window;

// DOM elements
let form;
let sendButton;
let captureLeadSuccess;
let captureLeadError;

const key = vars.recaptchaSiteKey;

// API URL (same logic as before)
// eslint-disable-next-line
const isStaging = process.env.APP_ENV === 'staging';
console.warn(isStaging);
console.warn(key);
const API_URL = isStaging
  ? 'https://akera.fr/staging/public/api/contact'
  : 'https://akera.fr/lepremium/public/api/contact';

// Initialize and attach submit handler
function init() {
  sendButton = $('.Contact--send');
  captureLeadSuccess = $('.Contact--success');
  captureLeadError = $('.Contact--error');

  form = $('.js-form-submit');
  if (form[0]) {
    form.on('submit', handleSubmitForm);
  }
  else {
    console.warn('A contact form with class \'.js-form-submit\' must be present in the DOM');
  }
}

// Show error UI
function _captureLeadError(error) {
  console.error(error);
  captureLeadError.show(0);
  throw error;
}

// Show success UI
function _captureLeadSuccess() {
  captureLeadError.hide(0);
  sendButton.hide(0);
  captureLeadSuccess.show(0);
  form[0].reset();
  // Redirect to thank you page
  window.location.href = '/thank';
}

// Form submit handler
function handleSubmitForm(event) {
  event.preventDefault();

  const firstName = form[0]['firstname'].value;
  const lastName  = form[0]['lastname'].value;
  const email     = form[0]['email'].value;
  const phone     = form[0]['phone'].value;
  const fonction  = form[0]['fonction'].value;
  const societe   = form[0]['societe'].value;
  const message   = form[0]['message'].value;

  // Build payload as Laravel expects
  const payload = {
    project_slug: vars.slug,
    lead: {
      first_name: firstName,
      last_name: lastName,
      email,
      phone,
      source: vars.source,
      message: `Société: ${societe} | Fonction: ${fonction} | Message: ${message}`,
    }
  };

  // Execute reCAPTCHA v3
  grecaptcha.ready(() => {
    grecaptcha.execute(vars.recaptchaSiteKey, { action: 'submit' }).then((token) => {

      // Attach token
      payload['g-recaptcha-response'] = token;

      // Send via fetch
      fetch(API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      })
        .then((res) => {
          if (!res.ok) {
            const errorData = res.json().catch(() => null);
            throw errorData || new Error(`HTTP ${res.status}`);
          }
          return res.json();
        })
        .then((result) => {
          console.warn('✅ Success:', result);
          _captureLeadSuccess();
        })
        .catch((error) => {
          console.error('❌ Error:', error);
          _captureLeadError(error);
          window.location.href = '/thank';
        });
    });
  });
}

export default {
  init,
};



// WEBPACK FOOTER //
// ./src/static/js/modules/submit-form.js